import React from 'react';
import connect from '~/store/connect';
import { State } from '~/store/types';
import { Button, Modal } from '@watcherr/ui';
import { t } from '~/i18n';

type TProps = {
  cancel: State['confirmation']['cancel'];
  confirm: State['confirmation']['confirm'];
  showModal: State['confirmation']['showModal'];
  message: State['confirmation']['message'];
  title: State['confirmation']['title'];
};

const ConfirmationContainer: React.FC<TProps> = ({ showModal, title, cancel, confirm, message }) => {
  if (!showModal) {
    return null;
  }
  return (
    <Modal onClose={cancel}>
      <h3>{title}</h3>
      <p className="mb-20">{message}</p>
      <div className="d-flex justify-content-end">
        <Button className="mr-15" buttonType="link" onClick={cancel}>
          {t('global.cancel')}
        </Button>
        <Button onClick={confirm}>{t('global.confirm')}</Button>
      </div>
    </Modal>
  );
};

export default connect((state: State) => ({
  cancel: state.confirmation.cancel,
  confirm: state.confirmation.confirm,
  showModal: state.confirmation.showModal,
  message: state.confirmation.message,
  title: state.confirmation.title,
}))(ConfirmationContainer);
